<template>
  <div class="row align-items-center justify-content-center">
    <input-number
      :value="range[0]"
      :min="get_min"
      :max="max_start_input"
      :disabled="disabled"
      style="width: 80px"
      @input="input_range($event, range[1])"
    />
    <span class="db-row__row-input-delimeter">&mdash;</span>
    <input-number
      :value="range[1]"
      :min="1"
      :max="max_end_input"
      style="width: 80px"
      :disabled="disabled"
      @input="input_range(range[0], $event)"
    />
  </div>
</template>
<script>
  export default {
    props: {
      recipients_count: {
        type: Number,
        default: 0
      },
      range: {
        type: Array,
        default: function () {
          return [0, 0];
        }
      },
      range_from_one: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      get_min() {
        return this.range_from_one ? 1 : 0;
      },
      max_start_input() {
        if (this.recipient_count <= 1) {
          return this.recipients_count;
        } else {
          return this.recipients_count - 1;
        }
      },
      max_end_input() {
        return this.recipients_count;
      },
      disabled() {
        return this.recipients_count <= 1;
      }
    },
    methods: {
      input_range(start, end) {
        this.$emit('range:update', [start, end]);
      }
    }
  };
</script>
